export const audience = {
  // Header
  "header.title": "Audiência Simulada",
  "header.subtitle": "Mostre um contador dinâmico de pessoas assistindo para gerar prova social durante o vídeo.",
  
  // Toggle principal
  "enable": "Audiência Simulada",
  "enable.helper": "Exibe um contador de pessoas assistindo no player.",
  
  // Tab labels
  "tab.config": "Configurações",
  "tab.style": "Estilo",
  
  // Card: Mensagem
  "msg.title": "Mensagem",
  "msg.format": "Formato da mensagem",
  "msg.placeholder": "Ao vivo — {count} pessoas assistindo agora",
  "msg.helper": "Use \"{count}\" para inserir o número de pessoas dinamicamente.",
  "msg.preview": "Prévia",
  
  // Card: Contagem
  "count.title": "Contagem",
  "count.base": "Contagem base",
  "count.base.helper": "Valor inicial para o contador.",
  "count.min": "Variação mínima",
  "count.max": "Variação máxima",
  "count.range.helper": "O contador oscilará dentro deste intervalo durante o vídeo.",
  
  // Card: Posição
  "style.title": "Estilo",
  "style.position.title": "Posição",
  "style.position": "Posição",
  
  // Card: Cores
  "style.colors.title": "Cores",
  "style.textColor": "Cor do texto",
  "style.bgColor": "Cor de fundo",
  "style.useTransparency": "Usar transparência no fundo",
  "style.opacity": "Opacidade",
  
  // Card: Tamanho da Fonte
  "style.fontSize.title": "Tamanho da fonte",
  "style.fontSize": "Tamanho",
  "size.small": "Pequeno",
  "size.medium": "Médio",
  "size.large": "Grande",
  
  // Posições (compatibilidade)
  "topLeft": "Superior Esquerdo",
  "topCenter": "Superior Centro",
  "topRight": "Superior Direito",
  "centerLeft": "Centro Esquerdo",
  "center": "Centro",
  "centerRight": "Centro Direito",
  "bottomLeft": "Inferior Esquerdo",
  "bottomCenter": "Inferior Centro",
  "bottomRight": "Inferior Direito"
};
